// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reorder-item[data-v-57a32705]{border:2px solid transparent;border-color:#8b8b8b;margin-left:4px;margin-right:4px}.reorder-item[data-v-57a32705]:hover{-webkit-transition:all .3s ease;transition:all .3s ease;cursor:-webkit-grab;cursor:grab;border:2px dashed transparent;border-color:#76b9fc;background-color:#d8e8fd!important}.reorder-item .handle[data-v-57a32705]{cursor:-webkit-grabbing;cursor:grabbing}.handle[data-v-57a32705]{cursor:-webkit-grab;cursor:grab;margin-left:10px}", ""]);
// Exports
module.exports = exports;
